/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
        .directive('accToggleDeleted', ['$cookieStore', function($cookieStore){
            return {
                priority: 1,
                controller: ['$scope', function($scope) {
                    var
                         FILTER_SESSION_KEY = 'sync_and_share_nodes_filter';

                    $scope.filters = {
                        filter_deleted: ($cookieStore.get(FILTER_SESSION_KEY) === '' ? '' : 'active')
                    };

                    $scope.table.toggleDeleted = function() {
                        if($scope.filters.filter_deleted == 'active') {
                            $scope.filters.filter_deleted = '';
                        } else {
                            $scope.filters.filter_deleted = 'active';
                        }
                        $scope.table.reload();
                        $cookieStore.put(FILTER_SESSION_KEY, $scope.filters.filter_deleted);
                    };

                    $scope.table.areDeletedShown = function() {
                        return $scope.filters.filter_deleted == '';
                    }
                }]
            }
        }]);
